import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8v3a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M18 8v8","key":"svg-1"}],["path",{"d":"M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4","key":"svg-2"}]]

const IconNumber54Small = createReactComponent('outline', 'number-54-small', 'Number54Small', __iconNode);

export default IconNumber54Small;